module.exports = __webpack_public_path__ + "static/img/qrcode_for_mp.c2264545.jpg";